<template>
  <div></div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

import { triggerBlockAction, BLOCK_ACTIONS } from "@/lib/stream-utils"

const QUEUE = {
  POST_SIGN_UP_FORM: "#auth/post-sign-up-form"
}

export default {
  computed: {
    ...mapState("router", ["queue"]),
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters(["appAccess"]),
    ...mapGetters("ui", ["isAlertDialogOpen"]),

    postSignUpAction() {
      return this.appAccess.post_sign_up_action
    }
  },

  data() {
    return {
      isTimingOut: false
    }
  },

  methods: {
    ...mapActions("forms", ["hasSubmittedForm"]),

    processQueue() {
      this.confirmCanShow().then(() => {
        const hash = this.$router.queue.nextItem()

        if (!hash) return

        switch (hash) {
          case QUEUE.POST_SIGN_UP_FORM:
            // I don't love the idea that this "router queue" can also sometimes
            // directly trigger block actions. I'd prefer it to just be purely
            // queueing hash's to be shown by the router at the next available moment
            // and then the consuming modal or component to decide what to do with it.
            // But for now, this is the simplest way to get this working.
            this.hasSubmittedForm(this.postSignUpAction.form_id).then(
              hasSubmitted => {
                // We need to double check that the form hasn't been submitted
                // as its possible that this hash can be queued more than once
                if (!hasSubmitted) {
                  triggerBlockAction(this.postSignUpAction, false, true)
                }
              }
            )

            break

          default:
            this.$router.push(hash)
        }

        this.$router.queue.remove(hash)
      })
    },

    confirmCanShow() {
      return new Promise(resolve => {
        if (this.isTimingOut) return

        if (this.canShow()) {
          this.isTimingOut = true

          setTimeout(() => {
            this.isTimingOut = false

            if (this.canShow()) {
              resolve()
            }
          }, 500)
        }
      })
    },

    canShow() {
      return !(this.$route.hash || this.isAlertDialogOpen)
    }
  },

  watch: {
    "$route.hash": {
      immediate: true,
      handler() {
        this.processQueue()
      }
    },

    queue: {
      immediate: true,
      handler() {
        this.processQueue()
      }
    },

    isAlertDialogOpen: {
      immediate: true,
      handler() {
        this.processQueue()
      }
    },

    isAuthenticated: {
      immediate: true,
      handler() {
        if (
          this.isAuthenticated &&
          this.postSignUpAction &&
          this.postSignUpAction.action === BLOCK_ACTIONS.TRIGGER_FORM &&
          this.postSignUpAction.form_id
        ) {
          this.hasSubmittedForm(this.postSignUpAction.form_id).then(
            hasSubmitted => {
              if (hasSubmitted) return

              this.$router.queue.push(QUEUE.POST_SIGN_UP_FORM)
            }
          )
        }
      }
    }
  }
}
</script>
